module.exports = __webpack_public_path__ + "images/ebaba9798691467dc06f411d7bd41779-profile_overlay.jpg";